// extracted by mini-css-extract-plugin
export default {"blocked-period-tooltip-view":"BlockedPeriodTooltipView_blocked-period-tooltip-view__QYHNa","title":"BlockedPeriodTooltipView_title__e9Jj7"};